import React, { useState, useEffect, useCallback } from 'react'
import Style from './teams.module.sass';
import { Button, Table, Dropdown, Menu, Tooltip, Checkbox, Empty } from 'antd';
import { Modal } from '../../../helpers/commonUi'
import search from '../../../assets/images/searchicon.png';
import _ from "lodash";
import { Http } from "../../../helpers/axois";
import { useParams, useHistory } from 'react-router-dom';
import { ITeamsDetails } from './teams';
import { ClickParam } from 'antd/lib/menu';
import { useToast } from '../../../helpers/commonFunction'
import { ReactComponent as Delete } from '../../../assets/svg/delete.svg'
import { ReactComponent as Settings } from '../../../assets/svg/modalSettingsIcon.svg'
import { ReactComponent as PolicyIcon } from '../../../assets/svg/action-dot-icon.svg'
import { ReactComponent as CloseIcon } from '../../../assets/svg/team-close.svg'

import { AddPolicyModal } from '../policy/AddPolicyModal'
import { useSelector } from "react-redux";

import EditCreateTeam from './editCreateTeam';
import teamIcon from '../../../assets/svg/teamIcon.svg'
import { Spinner } from '../../../helpers/commonUi/Spinner';
import { stringToHslColor } from '../../../helpers/util';
import { AppState } from '../../../stateManager/store';
let unsearchMembers: any;

export const Team: React.FC = ({ match }: any) => {
    const [teams, setTeams] = useState<ITeamsDetails[]>([]);
    const [selectedTeam, setSelectedTeam] = useState<ITeamsDetails | null>(null)
    // const [ selectedRowKeys, setSelectedRowKeys ] = useState<any>([]);
    const [searchMemberText, setSearchMemberText] = useState("")
    const [membersSearch, setMembersSearch] = useState<{ open: boolean, list: any[] }>({ open: false, list: [] });
    const [loading, setLoading] = useState(true);
    const [policyState, setPolicyState] = useState<boolean>(false);
    // const { teamId, orgId } = useParams();
    const [policyList, setPolicyList] = useState<any[]>([]);
    const { orgId } = useParams<any>();
    const { ErrorToast, SuccessToast, WarningToast } = useToast()
    const history = useHistory();
    const [visible, setVisible] = useState<boolean>(false)
    const [teamData, setTeamData] = useState<any>({})
    const [refresh, setRefresh] = useState<boolean>(false)
    const [popUpState, setPopUpState] = useState<any>({})
    const [deleteModalVisible, setdeleteModalVisible] = useState<boolean>(false);
    const [deleteUserModal, setDeleteUserModal] = useState<boolean>(false);
    const [deleteData, setDeleteData] = useState<any>({});
    const [policyModalVisible, setPolicyModalVisible] = useState<boolean>(false);
    const [addUserState, setAddUserState] = useState(false);
    const [removeUserIds, setRemoveUserIds]: any = useState([]);
    const { selectedOrg } = useSelector((state: AppState) => state.org)
    const loggedInUserId = useSelector((state: any) => {
        return state.user.data.user.id
    })
    const orgPermissions: any = useSelector((state: any) => {
        return state.org.orgPermissions
    }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))

    const canCreateTeam = orgPermissions.includes('team.Create')
    const canDeleteTeam = orgPermissions.includes('team.Delete')
    const canEditTeam = orgPermissions.includes('team.Edit')
    const canCreateUser = canEditTeam && orgPermissions.includes('user.Add')
    // const canDeleteUser = canEditTeam && orgPermissions.includes('user.Remove')
    const canViewPolicy = canEditTeam && orgPermissions.includes('policy.View')
    const canAttachPolicy = canEditTeam && orgPermissions.includes('policy.Attach')
    const canRemovePolicy = canEditTeam && orgPermissions.includes('policy.Remove')

    const CHOOSE_CREATE_TEAM = 'Choose or create new team'

    const getPolicy = useCallback(() => {
        Http.get(`/policy?orgId=${orgId}`).subscribe((res: any) => {
            setPolicyList(res);
        }, (err) => {
            ErrorToast('Error fetching policies');
        });
    }, [orgId, ErrorToast]);


    useEffect(() => {
        getPolicy();
    }, [getPolicy])

    useEffect(() => {
        const allTeamsApi = Http.get(`/teams/list/${orgId}`).subscribe((res: any) => {
            setLoading(false)
            if (res?.length > 0) {
                setTeams(res);
            } else {
                setTeams([]);
                history.push(`/organization/${orgId}/teams`)
            }
            setPolicyState(false);
        })
        return () => {
            allTeamsApi.unsubscribe();
        }
    }, [orgId, history, refresh, policyState]);
    // }, [teamId, orgId]);

    // useEffect(() => {
    //     // empty selected members while switching teams
    //     setSelectedRowKeys([])
    // }, [ selectedTeam ])

    const popUpContent = (team: any) => {
        const canDeleteTeamLocal = team.permissions.includes('team.Delete')
        const canEditTeamLocal = team.permissions.includes('team.Edit')
        const canAttachPolicyLocal = team.permissions.includes('policy.Attach')
        const canRemovePolicyLocal = team.permissions.includes('policy.Remove')
        const canViewPolicyLocal = team.permissions.includes('policy.View')
        return (
            <div className={Style.popUpContainer}>
                <div data-test-id="edit_team"  className={Style.popUpItem} onClick={(e) => {
                    e.stopPropagation()
                    if (canEditTeam || canEditTeamLocal) {
                        setTeamData(team)
                        setVisible(true)
                    } else {
                        ErrorToast('You are not authorized to edit this team')
                    }
                    setPopUpState({
                        [team.id]: false
                    })
                }}>
                    <Settings height='14px' width='14px' style={{ color: "#292d32" }}/>
                    <span className={Style.popUpItemText} style={{ color: "#292d32" }}>Edit</span>
                </div>
                <div data-test-id="delete_team" className={Style.popUpItem} onClick={(e) => {
                    e.stopPropagation()
                    if (canDeleteTeam || canDeleteTeamLocal) {
                        setdeleteModalVisible(true);
                        setDeleteData(team);
                    } else {
                        ErrorToast('You are not authorized to delete this team')
                    }
                    setPopUpState({
                        [team.id]: false
                    })
                }}>
                    <Delete height='14px' width='14px' />
                    <span className={Style.popUpItemText} style={{ color: "#292d32" }}>Delete</span>
                </div>
                <div data-test-id="update_team" className={Style.popUpItem} onClick={(e) => {
                    e.stopPropagation()
                    if ((canEditTeam || canEditTeamLocal) && (canViewPolicy || canViewPolicyLocal) && (canAttachPolicy || canAttachPolicyLocal || canRemovePolicy || canRemovePolicyLocal)) {
                        setPolicyModalVisible(true);
                        setTeamData({
                            ...team,
                            canAttach: canAttachPolicy || canAttachPolicyLocal,
                            canRemove: canRemovePolicy || canRemovePolicyLocal
                        });
                    } else {
                        ErrorToast("You are not authorized to update teams' policy")
                    }
                    setPopUpState({
                        [team.id]: false
                    })
                }}>
                    <PolicyIcon height='14px' width='14px' style={{ color: "#292d32" }} />
                    <span className={Style.popUpItemText} style={{ color: "#292d32" }}>Policy</span>
                </div>
                {/* <div className={Style.popUpItem}>
                    <Settings height='14px' width='14px'/>
                    <span className={Style.popUpItemText}>Delete</span>
                </div>
                <div className={Style.popUpItem}>
                    <Settings height='14px' width='14px'/>
                    <span className={Style.popUpItemText}>Info</span>
                </div> */}
            </div>
        )
    }

    // const onSelectChange = (rowKeys: any) => {
    //     setSelectedRowKeys(rowKeys);
    // };

    const removeUsersFromTeam = (userIds: string[]) => {
        if (userIds?.length === 0) {
            ErrorToast("Please select a user to delete")
            return
        };
        let teamId = selectedTeam && selectedTeam.id;
        Http.delete(`/team/${teamId}/${orgId}/user`, { data: { userIds: userIds } }).subscribe(res => {
            SuccessToast('User removed successfully');
            let newSelectedTeam: any = { ...selectedTeam };
            // let newMemberData = { userId: newAddedMember.usr_id, firstName: newAddedMember.first_name, lastName: newAddedMember.last_name, email: newAddedMember.email }
            userIds.forEach((userId: string) => {
                let deletedUserIndex = newSelectedTeam.teamMembers.findIndex((x: any) => x.userId === userId);
                if (deletedUserIndex >= 0) {
                    newSelectedTeam.teamMembers.splice(deletedUserIndex, 1);
                };
            });
            setSelectedTeam(newSelectedTeam);
        }, (err) => {
            ErrorToast((err && err.message) ? err.message : err)
        });
    };

    const deleteApps = (teamId: string) => {
        Http.delete(`/team/${teamId}?orgId=${orgId}`).subscribe(res => {
            setdeleteModalVisible(false);
            setRefresh(!refresh);
            SuccessToast('Team removed successfully');
        }, (err) => {
            setdeleteModalVisible(false);
        })
    };

    const renderMembersTable = () => {
        // const rowSelection: TableRowSelection<any> = {
        //     selectedRowKeys,
        //     onChange: onSelectChange,
        //     getCheckboxProps: (record) => ({
        //         disabled: record.userId === (selectedTeam && selectedTeam.createdBy), // Column configuration not to be checked
        //     }),
        // };

        let columns: any[] = [];

        !addUserState ? columns = [
            {
                title: 'Teams',
                dataIndex: 'teams',
                width: "25%"

            },

            {
                title: 'Policy',
                dataIndex: 'policy',
                width: "50%"

            },
            {
                title: 'Users',
                dataIndex: 'user',
                width: "30%"
            }


            // {
            //     title: 'Team',
            //     dataIndex: 'team',
            //     width: "170px"
            // },
            // {
            //     title: 'Role',
            //     dataIndex: 'role',
            //     width: "170px"
            // },
            // {
            //     title: 'Action',
            //     dataIndex: 'actions',
            //     render: (text: any, record: any, index: number) => {
            //         return (
            //             <div style={{ height: "35px" }}>
            //                 {/* <img src={editTeam} alt="edit" style={{ cursor: "pointer" }} />
            //             <Divider type="vertical" /> */}
            //                 {record.userId !== selectedTeam!.createdBy && <Popconfirm title="Confirm delete?" onConfirm={() => removeUsersFromTeam([record.userId])}>
            //                     <img src={deleteTeam} alt="delete" style={{ cursor: "pointer" }} />
            //                 </Popconfirm>}
            //             </div>
            //         )
            //     },
            //     width: "19%",
            //     height: "57px"
            // },
        ] : columns = [
            {
                title: 'Teams',
                dataIndex: 'teams',
                width: "30%"

            },

            {
                title: 'Policy',
                dataIndex: 'policy',
                width: "50%"
            }
        ]

        const data: any[] = [];
        teams && teams.map((item: any, i) => (
            data.push(
                {
                    teams: <div style={{ background: selectedTeam?.id === item.id ? "#fbfbfb" : "" }} key={i} className={Style.team_list}
                        onClick={() => { setAddUserState(true); handleTeamClick(item); setRemoveUserIds([]); }} >
                        <div className={Style.icon}>
                            <img src={teamIcon} alt={`${item.teamName} Logo`} />
                        </div>
                        <div className={Style.name}>
                            {item.teamName}
                            <div data-test-id="team_members" className={Style.length}>
                                {`${item.teamMembers && item.teamMembers.length} members`}
                            </div>
                        </div>
                    </div>,
                    policy: <div style={{ background: selectedTeam?.id === item.id ? "#fbfbfb" : "" }} className={Style.policies}
                        onClick={() => { setAddUserState(true); handleTeamClick(item); setRemoveUserIds([]); }}>
                        {
                            item.policies && item.policies.map((tp: any, i: any) => {
                                const policyInfo = policyList.find((item: any) => item.id_ === tp);
                                return <div key={i} className={Style.alignment}>
                                    {(tp && policyInfo) && <div className={Style.box}>
                                        <div className={Style.name}>{policyInfo && policyInfo.name}</div>
                                    </div>}
                                </div>
                            })
                        }
                    </div>,
                    user: <div key={i} className={Style.user} >
                        <div style={{ display: "flex" }} onClick={() => { setAddUserState(true); handleTeamClick(item); setRemoveUserIds([]); }}>
                            {
                                item.teamMembers && item.teamMembers.map((usr: any, i: number) => {
                                    if (i <= 3) {
                                        let word;
                                        let first;
                                        let second;
                                        word = usr.firstName && usr.firstName.split(" ")
                                        first = word[0][0]
                                        second = word[1] && word[1][0]
                                        return <div key={i} style={{ display: "flex", justifyContent: "space-between" }} >
                                            <div style={{ display: "flex" }} >
                                                <div className={Style.round_icon}>
                                                    <div className={Style.words}
                                                        style={{
                                                            backgroundColor: stringToHslColor(usr.lastName + usr.firstName, 70, 50, 15),
                                                            color: stringToHslColor(usr.lastName + usr.firstName, 70, 45),
                                                        }}>
                                                        {!usr.lastName ? (first + second)
                                                            : ((usr.firstName && usr.firstName[0]) + (usr.lastName && usr.lastName[0]))}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    } else {
                                        return i === 4 && <div key={i} style={{ display: "flex" }} >
                                            <div className={Style.round_icon}>
                                                <div className={Style.words}
                                                    style={{
                                                        backgroundColor: "rgba(215, 217, 229, 0.43)",
                                                        color: "#787C8D",
                                                    }}> {"+" + (item.teamMembers && item.teamMembers.length - 4)} </div>
                                            </div>
                                        </div>
                                    };
                                })
                            }
                        </div>
                        <div style={{ marginRight: "50px" }} key={item.id}
                            onClick={() => { handleTeamClick(item) }}
                            onContextMenu={(e) => {
                                e.preventDefault()
                                setPopUpState({
                                    [item.id]: true
                                })
                            }} >
                            <Tooltip
                                onVisibleChange={(value) => setPopUpState({
                                    [item.id]: value
                                })}
                                visible={popUpState[item.id]}
                                placement='rightTop'
                                overlayClassName='teamPopUp'
                                title={() => popUpContent(item)}
                                trigger='click'
                                key={i}
                            >
                                <div className={Style.edit_icon}>
                                    <PolicyIcon height="20px" />
                                </div>
                            </Tooltip>
                        </div>
                    </div>
                },
            )
        ))

        return (
            <div className={Style.membersTable} >
                <div >
                    <Table
                        data-test-id="team_table"
                        columns={columns}
                        dataSource={data}
                        // onRow={(record: any, rowIndex: any) => {
                        //     console.log("record", record)
                        //     return {
                        //         onClick: event => {
                        //             setAddUserState(true);
                        //         }
                        //     }
                        // }}
                        scroll={{ y: 'calc(100vh - 240px)' }}
                        className="override-table-container cus_team_header"
                        // useFixedHeader
                        // size="small"
                        // loading={loading ? { spinning: true, size: "large", indicator: <Icon type="loading" spin /> } : false}
                        // bodyStyle={{ margin: "0px" }}
                        // scroll={{ y: 315 }}
                        // scroll={{y: 'calc(100vh - 300px)'}}
                        pagination={false}
                    // pagination={{ className: Style.pagination }}
                    // style={{ backgroundColor: "#e7f2fe" }}
                    />
                </div>
            </div>);
    }

    // const handleActionsClick = ({key}: ClickParam) => {
    //     if (key === "delete") {
    //         removeUsersFromTeam(selectedRowKeys);
    //         setSelectedRowKeys([]);
    //     }
    // }

    const handleDelete = () => {
        removeUsersFromTeam(removeUserIds);
        setRemoveUserIds([]);
        setDeleteUserModal(false);
    }

    // const actions = (
    //     <Menu onClick={(param: ClickParam) => handleActionsClick(param)}>
    //         <Menu.Item key="delete">
    //             <div>DELETE</div>
    //         </Menu.Item>
    //     </Menu>
    // );

    const handleSearchedMemberSelect = (val: ClickParam) => {
        setMembersSearch({ ...membersSearch, open: false })
        setSearchMemberText(val.key);
    }

    const usersMenu = (<Menu
        data-test-id="menu"
        onClick={(val) => handleSearchedMemberSelect(val)}
        style={{ marginLeft: "-25px", maxHeight: "500px", overflowY: "auto" }}>
        {membersSearch.list.length > 0 ? membersSearch.list.map((mem, index) => (
            <Menu.Item data-test-id={`email${mem.email}`} key={mem.email}>
                <div style={{ display: "flex" }}>
                    <div style={{ marginLeft: "10px" }}>
                        <div style={{ fontStyle: "normal", fontWeight: 500, fontSize: "14px", color: "#000000" }}>{mem.first_name}</div>
                        <div style={{ fontStyle: "normal", fontWeight: 400, fontSize: "14px", color: "#787C8D" }}>{mem.email}</div>
                    </div>
                </div>
            </Menu.Item>
        )) : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
    </Menu>);

    const handleSeachMembers = _.debounce((value: string) => {
        if ((!orgPermissions?.includes("user.View") || !orgPermissions.includes('org.View')) &&  loggedInUserId!=selectedOrg?.owner) {
            ErrorToast("Error fetching users")
            return
          } 
        if (value) {
            if (unsearchMembers) {
                unsearchMembers.unsubscribe()
            }
            //call api call.
            unsearchMembers = Http.get(`/users?search=${value}&orgId=${orgId}`).subscribe((res: any) => {
                    setMembersSearch({ open: true, list: res });
                }
            , (err: any) => {
                if (err === "Forbidden") {
                    ErrorToast("Error fetching users")
                }
            })
        } else {
            setMembersSearch({ open: false, list: [] });
        }
    }, 500);

    const handleAddTeam = () => {
        // history.push(`/organization/${orgId}/teams/create`)
        setTeamData({})
        setVisible(true)
    }

    const handleTeamClick = (team: ITeamsDetails) => {
        setSelectedTeam(team);
        // setTeamData(team)
        // setVisible(true)
        history.push(`/organization/${orgId}/teams/${team.id}`)
    }

    const handleAddTeamMember = () => {
        if (searchMemberText && membersSearch.list.length > 0) {
            const newAddedMember = membersSearch.list.filter(x => x.email === searchMemberText)[0];
            const teamId = selectedTeam && selectedTeam.id;
            Http.post(`/team/${teamId}/${orgId}/user`, { userList: [`${newAddedMember.usr_id}`] }).subscribe((res) => {
                SuccessToast('User added successfully')
                let newSelectedTeam: any = { ...selectedTeam };
                let newMemberData = {
                    userId: newAddedMember.usr_id,
                    firstName: newAddedMember.first_name,
                    lastName: newAddedMember.last_name,
                    email: newAddedMember.email
                }
                newSelectedTeam.teamMembers.push(newMemberData);
                setSelectedTeam(newSelectedTeam);
            }, (err) => {
                ErrorToast((err && err.message) ? err.message : err)
            })
            setMembersSearch({ ...membersSearch, list: [] });
            setSearchMemberText("");
        } else {
            WarningToast('Please search for valid users')
        }
    }


    if (loading) {
        return <Spinner />
    }


    const onRemoveUser = (userId: string) => {
        if (removeUserIds.indexOf(userId) > -1) {
            setRemoveUserIds(removeUserIds.filter((id: string) => id !== userId));
        } else {
            setRemoveUserIds([...removeUserIds, userId]);
        }
    }
    return (
        <>
            <div className={Style.teams}>
                <div className="row">
                    <div className="col" style={{ paddingRight: addUserState ? "0px" : "15px" }}>
                        {
                            <div style={{ display: 'flex' }}>
                                <div className={Style.mainorgs} style={{ width: "100%", paddingRight: addUserState ? "0px" : "27px" }} >
                                    <div className={Style.mainSubOrgs} style={{ display: "flex", justifyContent: "space-between" }}>
                                        <div className={Style.mainSubOrgsContent}>
                                            <h3>{'Team'}</h3>
                                            <p>{CHOOSE_CREATE_TEAM}</p>
                                        </div>
                                        {canCreateTeam && !addUserState && <div className={Style.add} >
                                            <Button
                                                style={{
                                                    width: "135px",
                                                    height: "36px",
                                                    cursor: "pointer",
                                                    border: "#0466C8",
                                                    backgroundColor: "#51808c",
                                                    boxShadow: "0px 8px 13px #51808c10"
                                                }} type="primary" onClick={handleAddTeam}>
                                                CREATE TEAM
                                            </Button>
                                        </div>}
                                        {/* <div className={Style.header} style={{display: "flex", alignItems: "center"}}>
                                            <div style={{fontWeight: 400, fontSize: "14px", color: "#000000", fontStyle: "normal", marginRight: "10px"}} >{canCreateTeam ? 'CREATE TEAM' : 'TEAMS LIST'}</div>
                                            {
                                                canCreateTeam && <PlusIcon data-test-id="plus" width="24px" height="24px" onClick={handleAddTeam} />
                                            }
                                        </div> */}
                                    </div>

                                    <div data-test-id="column">
                                        {renderMembersTable()}
                                    </div>
                                </div>
                                <div style={{ height: window.innerHeight - 100, transition: 'width 0.5s', width: addUserState ? "480px" : "0px", zIndex: 9999 }}>
                                    {addUserState && <div style={{ height: window.innerHeight - 100 }} className={Style.side_panel}>
                                        <div >
                                            <div className={Style.header}>
                                                <div className={Style.title}>Team Users</div>
                                                <div className={Style.close_icon}
                                                    onClick={() => { setAddUserState(false); setSelectedTeam(null); setSearchMemberText(""); setRemoveUserIds([]) }}>
                                                    <CloseIcon />
                                                </div>
                                            </div>
                                            <div style={{ display: "flex", marginBottom: "20px" }}>
                                                {
                                                    canCreateUser && selectedTeam &&
                                                    <>
                                                        <div data-test-id="new_search_wrapper" id="newSearchWrapper" className={Style.search}>
                                                            <img src={search} alt="" />
                                                            <Dropdown
                                                                data-test-id="users_menu"
                                                                overlay={usersMenu}
                                                                visible={membersSearch.open}
                                                                overlayStyle={{ width: "345px", paddingTop: "3px" }}
                                                                onVisibleChange={(value: boolean) => value === false && setMembersSearch({ open: value, list: [] })}
                                                                trigger={["click"]}
                                                            >
                                                                <input data-test-id="search" type="search" style={{ width: "303px" }}
                                                                    value={searchMemberText}
                                                                    onChange={(e) => { setSearchMemberText(e.target.value); handleSeachMembers(e.target.value) }} />
                                                            </Dropdown>
                                                        </div>
                                                        <div className={Style.add} >
                                                            <Button style={{ width: "70px", height: "36px", border: "#0466C8", backgroundColor: "#0466C8", boxShadow: "0px 8px 13px #0466c84d" }} type="primary"
                                                                onClick={() => handleAddTeamMember()}>ADD</Button>

                                                        </div>
                                                    </>
                                                }
                                                {/* {
                                                    canDeleteUser && selectedTeam &&
                                                    <Button dataTestId="delete" size="small" color='light-secondary' onClick={handleDelete}>
                                                        <div className={Style.delete}>
                                                            <Delete />
                                                            <span>DELETE</span>
                                                        </div>
                                                    </Button>
                                                } */}
                                            </div>
                                            <div style={{ height: window.innerHeight - 300, width: "100%", overflowY: "auto" }}>
                                                {
                                                    selectedTeam && selectedTeam.teamMembers && selectedTeam.teamMembers!.map((mem: any, i) => {
                                                        return mem && <div key={mem.userId}>
                                                            <div style={{ display: "flex" }}>
                                                                {selectedTeam && selectedTeam.createdBy !== mem.userId &&
                                                                    <Checkbox checked={removeUserIds.indexOf(mem.userId) > -1} onChange={() => { onRemoveUser(mem.userId) }} />}
                                                                <div style={{
                                                                    display: "flex",
                                                                    flexDirection: "column",
                                                                    marginLeft: selectedTeam && selectedTeam.createdBy !== mem.userId ? "10px" : "26px"
                                                                }}>
                                                                    <div className={Style.user_firstLast_name}>
                                                                        {`${mem.firstName ? mem.firstName : ""} ${mem.lastName ? mem.lastName : ""} ${(selectedTeam && selectedTeam.createdBy) === mem.userId ? `(Owner)` : ""} `}
                                                                    </div>
                                                                    <div className={Style.user_email}>
                                                                        {mem.email && mem.email}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className={Style.bottom_line}></div>
                                                        </div>
                                                        // key: mem.userId,
                                                        // userId: mem.userId,
                                                        // name: `${mem.firstName ? mem.firstName : ""} ${mem.lastName ? mem.lastName : ""} ${(selectedTeam && selectedTeam.createdBy) === mem.userId ? `(Owner)` : ""} `,
                                                        // email: mem.email
                                                    })
                                                }
                                            </div>

                                        </div>
                                        {removeUserIds && removeUserIds.length > 0 ? <div
                                            className={Style.remove_btn}
                                            onClick={() => setDeleteUserModal(true)}>
                                            <div className={Style.label}>Remove</div>
                                        </div> : <></>}
                                    </div>}
                                    <Modal
                                        className={Style.deleteModal_teamUser}
                                        id="deleteTeam"
                                        dataTestId="delete_team"
                                        unmountOnCancel={true}
                                        visible={deleteUserModal}
                                        title="DELETE USER"
                                        onCancel={() => {
                                            setDeleteUserModal(false);
                                        }}

                                        footer={{
                                            enable: true,
                                            okText: 'DELETE',
                                            cancelText: 'CANCEL',
                                            onOk: () => {
                                                handleDelete();
                                            }
                                        }}
                                    >

                                        <div style={{ color: "#787C8D", fontSize: "14px", fontWeight: 700 }}>
                                            Do you want to delete the {removeUserIds && removeUserIds.length > 1 ? "users ?" : "user ?"}
                                        </div>
                                        <div className={Style.delete_user_details}>
                                            {removeUserIds && removeUserIds.map((ids: any) => {
                                                return <div >
                                                    {
                                                        selectedTeam?.teamMembers && selectedTeam?.teamMembers.map((user: any) => {
                                                            if (ids === user.userId) {
                                                                return <div className={Style.user_name} >{user.firstName}</div>
                                                            }
                                                            return null
                                                        })
                                                    }
                                                </div>
                                            })}
                                        </div>
                                    </Modal>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
            <EditCreateTeam data={teamData} visible={visible} setVisible={setVisible} setRefresh={setRefresh} refresh={refresh} />
            <Modal
                id="deleteTeam"
                dataTestId="delete_team"
                unmountOnCancel={true}
                visible={deleteModalVisible}
                title="DELETE TEAM"
                onCancel={() => {
                    setdeleteModalVisible(false);
                }}
                deleteOptions={{
                    type: "Team",
                    validateString: deleteData && deleteData.teamName
                }}
                footer={{
                    enable: true,
                    okText: 'DELETE',
                    cancelText: 'CANCEL',
                    onOk: () => {
                        deleteApps(deleteData.id)
                    }
                }}
            />
            {
                policyModalVisible &&
                <AddPolicyModal
                    from='team'
                    orgId={orgId}
                    data={teamData}
                    policyModalVisible={policyModalVisible}
                    setPolicyState={setPolicyState}
                    setPolicyModalVisible={setPolicyModalVisible}
                />
            }
        </>
    )
}
